'use strict';

const { h } = require('phy');

function getImageSource(data, size) {
  const media =
    data &&
    data.length &&
    data.find(
      ({ isMainImage, mediaType }) =>
        !isMainImage && mediaType === 'OfferCalloutImage'
    );

  if (!media) {
    return null;
  }

  return media.mediaUrl.replace(
    '{{options}}',
    `w_${size.width},h_${size.height},`
  );
}

function OfferCalloutImage({ className = '', alt, data, size, lazy = true }) {
  const imageSource = getImageSource(data, size);

  return h('img', {
    class: `${lazy && 'lazy-load no-bg'} ${className}`,
    'data-src': imageSource,
    src: lazy
      ? 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      : imageSource,
    alt,
    width: size.width,
    height: size.height,
  });
}

module.exports = OfferCalloutImage;
